/* Product page behaviour — Phase 6d.
 *
 * Three jobs, nothing else:
 *   1. Enable the hidden variant input and keep it pointing at the variant
 *      the radios describe. Until this runs the input is disabled, so a
 *      browser with no JavaScript submits the <noscript> select instead and
 *      exactly one control named "id" is ever posted.
 *   2. Keep price, stock line and button label truthful for the selection,
 *      and put ?variant= in the address bar so a link is shareable.
 *   3. Hide the sticky mobile bar while the real button is on screen. The
 *      bar is visible by default, so with no JavaScript it behaves as
 *      Phase 5 approved it.
 *
 * No storage of any kind (CLAUDE.md §2.8).
 */
(function () {
  const section = document.querySelector('[data-variant-data]')?.closest('.shopify-section');
  if (!section) return;

  const dataEl = section.querySelector('[data-variant-data]');
  const picker = section.querySelector('[data-variant-picker]');
  const idInput = section.querySelector('[data-variant-id]');
  const priceEls = section.querySelectorAll('[data-buy-price]');
  const addButtons = section.querySelectorAll('[data-add-button]');
  const addLabels = section.querySelectorAll('[data-add-label]');
  const stockLine = section.querySelector('[data-stock-line]');
  const mediaFigure = section.querySelector('[data-pdp-media]');

  let variants = [];
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch {
    return; // Leave the server-rendered state alone rather than half-apply.
  }

  // Step 1 — hand control of the "id" field to this script.
  if (idInput) idInput.disabled = false;

  const selectedOptions = () => {
    if (!picker) return [];
    return [...picker.querySelectorAll('input[type="radio"]:checked')]
      .sort((a, b) => a.dataset.optionPosition - b.dataset.optionPosition)
      .map((input) => input.value);
  };

  const matchVariant = (chosen) =>
    variants.find((variant) =>
      variant.options.every((value, index) => value === chosen[index])
    );

  let first = true;

  const update = () => {
    const chosen = selectedOptions();
    const variant = chosen.length ? matchVariant(chosen) : variants[0];

    if (!variant) {
      addButtons.forEach((button) => (button.disabled = true));
      addLabels.forEach((label) => (label.textContent = 'Unavailable'));
      if (stockLine) stockLine.hidden = true;
      return;
    }

    if (idInput) idInput.value = variant.id;
    // innerHTML, not textContent: `price` is the shop's own money_format
    // output and arrives HTML-encoded (&pound;35.00).
    priceEls.forEach((el) => (el.innerHTML = variant.price));

    addButtons.forEach((button) => (button.disabled = !variant.available));
    addLabels.forEach((label, index) => {
      if (!variant.available) {
        label.textContent = 'Sold out';
      } else {
        // The buy-box button carries the price; the sticky bar shows it
        // separately, so repeating it there would be noise.
        label.innerHTML = index === 0 ? `Add to basket — ${variant.price}` : 'Add to basket';
      }
    });

    if (stockLine) stockLine.hidden = !variant.available;

    // Never on the first pass. Swapping the gallery on load threw away the
    // srcset the server rendered and re-fetched a single fixed-width image,
    // which is a straight LCP regression for a change nobody asked for.
    if (!first && variant.media && mediaFigure) {
      const img = mediaFigure.querySelector('img');
      if (img && img.src !== variant.media.src) {
        img.srcset = '';
        img.src = variant.media.src;
        if (variant.media.alt) img.alt = variant.media.alt;
      }
    }
    first = false;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };

  picker?.addEventListener('change', update);
  update();

  // Step 3 — sticky bar yields while the real button is visible.
  //
  // Note for anyone testing this in a headless or embedded browser: the
  // Claude browser pane reports document.visibilityState === 'hidden', and
  // a hidden page fires no IntersectionObserver callbacks, no rAF and no
  // scroll events. This looked like a broken observer for a while
  // (2026-08-17); it is not. Verify the bar in a real browser window.
  const stickyBar = section.querySelector('[data-sticky-buy]');
  const primaryButton = section.querySelector('.buy-form [data-add-button]');
  if (stickyBar && primaryButton && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      ([entry]) => stickyBar.classList.toggle('sticky-buy-idle', entry.isIntersecting),
      { threshold: 0 }
    );
    observer.observe(primaryButton);
  }
})();
